import EnumSet from 'Services/enumSet'

interface INegotiationSortTypes extends EnumSet {
  none: number
  purchaseDate: number
  unreadFirst: number
  budgetSent: number
}

const NegotiationOrderTypes = new EnumSet({
  none: { value: 0, description: 'Indefinido' },
  purchaseDate: { value: 1, description: 'Data de aquisição' },
  unreadFirst: { value: 2, description: 'Mensagens não lidas' },
  budgetSent: { value: 3, description: 'Orçamento enviado' },
}) as INegotiationSortTypes

export default NegotiationOrderTypes